/* LAS dimension overlay: light gray width/height lines with end dots over the 3D preview.
   Reads the numbers from the Glass Size caption ("Small 20 x 12 mm ..."), so it follows
   whatever is set in the theme editor. Shown only while no engraving is set, the piece is
   facing front, and the user is not dragging. Hooks Three.js without touching the engines. */
(function(){
  if (window.__lasDimOverlay) return; window.__lasDimOverlay = true;
  var app = document.getElementById('las-app'); if (!app) return;
  var stage = app.querySelector('.stage'); if (!stage) return;
  var canvas = stage.querySelector('canvas'); if (!canvas) return;

  var LINE = '#C9C7C2', INK = '#8e8d89', GAP = 14, NS = 'http://www.w3.org/2000/svg';
  var st = { scene:null, cam:null, pending:false, dragging:false, rest:null, lastShow:false };
  var svg, lw, lh, tw, th, dots = [];

  function el(tag, attrs){ var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); svg.appendChild(e); return e; }
  function build(){
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:visible;opacity:0;transition:opacity .25s ease;z-index:2';
    var L = { stroke:LINE, 'stroke-width':'1' };
    lw = el('line', L); lh = el('line', L);
    for (var i = 0; i < 4; i++) dots.push(el('circle', { r:'2', fill:LINE }));
    var T = { fill:INK, 'font-size':'11', 'letter-spacing':'0.06em', style:'font-family:inherit' };
    tw = el('text', T); tw.setAttribute('text-anchor', 'middle');
    th = el('text', T); th.setAttribute('dominant-baseline', 'middle');
    stage.appendChild(svg);
  }
  function hide(){ if (svg) svg.style.opacity = '0'; st.lastShow = false; }

  function dims(){
    var s = '', h = document.getElementById('shapeDims');
    if (h) s = h.textContent || '';
    if (!/\d\s*x\s*\d/i.test(s)){
      var hs = app.querySelectorAll('.hint');
      for (var i = 0; i < hs.length; i++){ var t = hs[i].textContent || ''; if (/\d\s*x\s*\d[^,]*mm/i.test(t)){ s = t; break; } }
    }
    var m = s.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*mm/i);
    return m ? { w:m[1], h:m[2] } : null;
  }
  function engraved(){
    var ids = ['valFront', 'valBack'];
    for (var i = 0; i < ids.length; i++){
      var e = document.getElementById(ids[i]); if (!e) continue;
      var t = (e.textContent || '').trim().toLowerCase();
      if (t && t !== 'none' && t !== '\u2014' && t !== '-') return true;
    }
    return false;
  }
  function visible(o){ while (o){ if (!o.visible) return false; o = o.parent; } return true; }
  function usable(o){
    if (!o.isMesh || !o.geometry || !visible(o)) return false;
    var m = o.material; if (m && (m.isShadowMaterial || (m.transparent && m.opacity < 0.05))) return false;
    if (/shadow|ground|floor|backdrop|bg/i.test(o.name || '')) return false;
    return true;
  }

  function update(){
    st.pending = false;
    if (!svg) build();
    var d = dims();
    if (!d || !st.scene || !st.cam || st.dragging || engraved()) return hide();
    var THREE = window.THREE;
    st.scene.updateMatrixWorld(true);
    var box = new THREE.Box3(), big = null, bigV = -1;
    st.scene.traverse(function(o){
      if (!usable(o)) return;
      if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
      var b = o.geometry.boundingBox.clone().applyMatrix4(o.matrixWorld);
      box.union(b);
      var s = b.getSize(new THREE.Vector3()), vol = s.x * s.y + s.y * s.z + s.x * s.z;
      if (vol > bigV){ bigV = vol; big = o; }
    });
    if (box.isEmpty() || !big) return hide();

    var q = new THREE.Quaternion(), cq = new THREE.Quaternion();
    big.getWorldQuaternion(q); st.cam.getWorldQuaternion(cq);
    var rel = cq.invert().multiply(q);
    if (!st.rest) st.rest = rel.clone();
    if (rel.angleTo(st.rest) > 0.14) return hide();

    var cw = canvas.clientWidth, ch = canvas.clientHeight; if (!cw || !ch) return hide();
    var cr = canvas.getBoundingClientRect(), sr = stage.getBoundingClientRect();
    var ox = cr.left - sr.left, oy = cr.top - sr.top;
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, v = new THREE.Vector3();
    for (var i = 0; i < 8; i++){
      v.set(i & 1 ? box.max.x : box.min.x, i & 2 ? box.max.y : box.min.y, i & 4 ? box.max.z : box.min.z).project(st.cam);
      var x = (v.x + 1) / 2 * cw + ox, y = (1 - v.y) / 2 * ch + oy;
      if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
    }
    if (!(x1 - x0 > 8 && y1 - y0 > 8)) return hide();

    var ty = y0 - GAP, tly = ty - 9;
    if (tly < 10){ ty = y1 + GAP; tly = ty + 16; }
    var right = x1 + GAP + 48 <= stage.clientWidth;
    var rx = right ? x1 + GAP : x0 - GAP;

    set(lw, x0, ty, x1, ty); set(lh, rx, y0, rx, y1);
    dot(0, x0, ty); dot(1, x1, ty); dot(2, rx, y0); dot(3, rx, y1);
    tw.setAttribute('x', (x0 + x1) / 2); tw.setAttribute('y', tly); tw.textContent = d.w + ' mm';
    th.setAttribute('x', right ? rx + 8 : rx - 8); th.setAttribute('y', (y0 + y1) / 2);
    th.setAttribute('text-anchor', right ? 'start' : 'end'); th.textContent = d.h + ' mm';
    svg.style.opacity = '1'; st.lastShow = true;
  }
  function set(l, a, b, c, e){ l.setAttribute('x1', a); l.setAttribute('y1', b); l.setAttribute('x2', c); l.setAttribute('y2', e); }
  function dot(i, x, y){ dots[i].setAttribute('cx', x); dots[i].setAttribute('cy', y); }
  function schedule(){ if (!st.pending){ st.pending = true; requestAnimationFrame(update); } }

  function hook(){
    var P = window.THREE.Object3D.prototype, orig = P.onBeforeRender;
    P.onBeforeRender = function(r, scene, cam){
      if (r && r.domElement === canvas && scene && cam){ st.scene = scene; st.cam = cam; schedule(); }
      return orig ? orig.apply(this, arguments) : undefined;
    };
  }
  (function wait(n){
    if (window.THREE && window.THREE.Object3D) return hook();
    if (n < 300) setTimeout(function(){ wait(n + 1); }, 50);
  })(0);

  canvas.addEventListener('pointerdown', function(){ st.dragging = true; hide(); });
  window.addEventListener('pointerup', function(){ if (!st.dragging) return; st.dragging = false; setTimeout(schedule, 350); });
  window.addEventListener('resize', schedule);
  if (window.MutationObserver){
    var mo = new MutationObserver(schedule);
    ['shapeDims', 'valFront', 'valBack'].forEach(function(id){ var e = document.getElementById(id); if (e) mo.observe(e, { childList:true, characterData:true, subtree:true }); });
  }
})();
